
let Timer;
export let TimeOutSet = (fun, time =  3000) => {
    TimeOutRemove();
    Timer = setTimeout(() => {
        fun();
    }
        , time)
};

export let TimeOutRemove = () => {
    if (Timer) {
        clearTimeout(Timer);
    }
}; 